import styled from "styled-components";

export const MainSectionContainer = styled.div`
  margin-top: 20px;
  padding-bottom: 20px;
  margin-left: -30px;
  margin-right: -30px;
  height: 92%;
  overflow-y: auto;
`;

const Styles = {
  MainSectionContainer,
};

export default Styles;
